import React, { useContext, useEffect } from "react";
import "./CancelPopup.scss";
import AppContext from "../../config/AppContext";

const CancelPopup = ({
  open,
  onClose,
  onConfirm,
  title,
  content,
  confirmText,
  cancelText,
}) => {
  const { mode } = useContext(AppContext);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && open) {
        onConfirm();
        onClose();
      } else if (event.key === "Escape" && open) {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, onConfirm, onClose]);

  if (!open) return null;

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("backdrop")) {
      onClose();
    }
  };

  return (
    <div className="backdrop" onClick={handleBackdropClick}>
      <div
        className={
          mode === "dark" ? "cancel-containerDark" : "cancel-container"
        }
      >
        <span className={mode === "dark" ? "cancel-titleDark" : "cancel-title"}>
          {title}
        </span>
        <span
          className={
            mode === "dark" ? "horizontal-cancelDark" : "horizontal-cancel"
          }
        ></span>
        <p
          className={mode === "dark" ? "cancel-contentDark" : "cancel-content"}
        >
          {content}
        </p>
        <div className="cancel-buttons">
          <button
            className={
              mode === "dark" ? "cancelPop-buttonDark" : "cancelPop-button"
            }
            onClick={onClose}
          >
            {cancelText}
          </button>
          <button
            className="confirmPop-button"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelPopup;
